export default __webpack_public_path__ + "static/hip-image-xray-v2-aea6834b6f893dbdb6a2d27f296e0536.png";